import { Info, Loader } from "lucide-react";
import { Button } from "./ui/button";

interface ReportHeaderProps {
  primaryInfo: string | null;
  secondaryInfo: string;
  handleExportPdf?: () => void;
  handleExportExcel?: () => void;
  handleExportCsv?: () => void;
  handleInfoClick?: () => void;
  loading?: boolean;
}

export const ReportHeader = ({
  primaryInfo,
  secondaryInfo,
  handleExportPdf,
  handleExportExcel,
  handleExportCsv,
  handleInfoClick,
  loading = false,
}: ReportHeaderProps) => {
  const displayPrimaryInfo = primaryInfo || secondaryInfo;
  const displaySecondaryInfo = primaryInfo ? secondaryInfo : "";

  return (
    <div className="p-4 shadow-sm rounded-lg mt-4 flex flex-col md:flex-row justify-between items-start md:items-center gap-4 dark:border dark:border-white">
      <div>
        <div className="flex gap-2 items-center">
          <h2 className="text-lg font-semibold">{displayPrimaryInfo}</h2>
          {handleInfoClick && (
            <Button
              variant="ghost"
              size="sm"
              className="p-1"
              onClick={handleInfoClick}
            >
              <Info className="w-4 h-4 text-foreground dark:text-white" />
            </Button>
          )}
        </div>
        {displaySecondaryInfo && (
          <p className="text-gray-500 text-sm mt-1">{displaySecondaryInfo}</p>
        )}
      </div>

      <div className="flex gap-2">
        {handleExportPdf && (
          <Button
            variant="outline"
            className="flex items-center gap-2 dark:text-white dark:border-white"
            onClick={handleExportPdf}
            disabled={loading}
          >
            {loading ? (
              <Loader className="w-4 h-4 animate-spin" />
            ) : (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                className="lucide lucide-file-type-pdf"
              >
                <path d="M14.5 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7.5L14.5 2z" />
                <polyline points="14 2 14 8 20 8" />
                <path d="M9 15v-2h6v2" />
                <path d="M11 13v6" />
                <path d="M9 19h4" />
              </svg>
            )}
            Exportar Pdf
          </Button>
        )}
        {handleExportExcel && (
          <Button
            variant="outline"
            className="flex items-center gap-2 dark:text-white dark:border-white"
            onClick={handleExportExcel}
            disabled={loading}
          >
            {loading ? (
              <Loader className="w-4 h-4 animate-spin" />
            ) : (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                className="lucide lucide-file-type-excel"
              >
                <path d="M14.5 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7.5L14.5 2z" />
                <polyline points="14 2 14 8 20 8" />
                <path d="M11 15l-2 3h4l-2 3" />
                <path d="M10 15l2 3h4l-2 3" />
              </svg>
            )}
            Exportar Excel
          </Button>
        )}
        {handleExportCsv && (
          <Button
            variant="outline"
            className="flex items-center gap-2 dark:text-white dark:border-white"
            onClick={handleExportCsv}
            disabled={loading}
          >
            {loading ? (
              <Loader className="w-4 h-4 animate-spin" />
            ) : (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                className="lucide lucide-file-type-csv"
              >
                <path d="M14.5 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7.5L14.5 2z" />
                <polyline points="14 2 14 8 20 8" />
                <path d="M11 15h1c.5 0 1 .5 1 1v1s-.5 1-1 1h-1a1 1 0 0 1-1-1v-1c0-.5.5-1 1-1Z" />
                <path d="M15 18h-.5a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5H15v-1h-1.5" />
              </svg>
            )}
            Exportar CSV
          </Button>
        )}
      </div>
    </div>
  );
};

export default ReportHeader;
